const Default = (props) => {
  const { children } = props
  return children
}

export default Default
